
const HeaderDom = () => (
    <div></div>
);

export default function Header(props) {
    return (
        <>
            <HeaderDom />
        </>
    );
};